import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { CampaignWiseReportApi, DownloadCampaignWiseReportApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper";
import { BsFiletypeDoc, BsFiletypeDocx, BsFiletypePdf, BsFiletypeXls, BsFiletypeXlsx } from "react-icons/bs";
import { FaFile } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { isJSONString } from "../Chatbox/ChatBox";
import { saveAs } from "file-saver";
import { IoMdArrowRoundBack } from "react-icons/io";
import ReactSelect, { components } from "react-select";

interface ReportDataType {
    createdAt: string,
    direction: string,
    error_code: number,
    error_message: string,
    from: string,
    id: number,
    media_url: string,
    message: string,
    message_type: string,
    retry_sms_id: number | null,
    sms_gateway_name: string,
    status: number,
    to: string,
    user: {
        name: string,
        email: string,
        role: number
    } | null
}

export default function MonitorCampaignWiseReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const { state } = useLocation();
    const [users, setUsers] = useState<{ id: number; name: string }[]>([]);
    const [selectDateName, setSelectDateName] = useState("Select Date");
    const navigate = useNavigate();
    const statusOption = [
        { value: 0, label: "Pending" },
        { value: 1, label: "Sent" },
        { value: 2, label: "Delivered" },
        { value: 3, label: "Undelivered" },
        { value: 4, label: "Failed" },
        { value: 5, label: "Delivery Unknown" },
        { value: 6, label: "Delivery Unconfirmed" },
        { value: 7, label: "Unknown Gateway" },
    ];
    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<{
        user_id: number[];
        message_type: string,
        from: string,
        to: string,
        direction: string,
        status: number[],
        sms_gateway_name: string,
        retry_sms_id: number | null,
        error_code: string,
        from_date: string,
        to_date: string,
    }>({
        user_id: [],
        message_type: "",
        from: "",
        to: "",
        direction: "",
        status: [],
        sms_gateway_name: "",
        retry_sms_id: null,
        error_code: "",
        from_date: "",
        to_date: "",
    });
    const [page, setPage] = useState(1);

    const userList = useQuery({
        queryKey: ["User-List-API"],
        queryFn: UserListApi,
        onSuccess: (resp: AxiosResponse) => {
            setUsers(resp.data?.users || []);
        },
        enabled: false,
    });

    const Report = useQuery({
        queryKey: ["Campaign-Wise-Report", state?.id, page, Filter],
        queryFn: CampaignWiseReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["Campaign-Wise-Report-Download", state?.id, page, Filter],
        queryFn: DownloadCampaignWiseReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `Campaign_Wise_Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        if (!state?.id) navigate("/report/campaign-wise/campaign-list");
        Report.refetch();
        userList.refetch();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        setPage(1)
        const handler = setTimeout(() => {
            Report.refetch();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter.user_id, Filter.direction, Filter.error_code, Filter.from, Filter.message_type, Filter.retry_sms_id, Filter.sms_gateway_name, Filter.status, Filter.to]);



    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDateName]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setSelectDateName("Select Date")
        setFilter({
            user_id: [],
            message_type: "",
            from: "",
            to: "",
            direction: "",
            status: [],
            sms_gateway_name: "",
            retry_sms_id: null,
            error_code: "",
            from_date: "",
            to_date: "",
        });
        Report.refetch();
    };

    const downloadMedia = async (imgUrl: string) => {
        fetch(imgUrl)
            .then((response) => response.blob())
            .then((blob) => {
                saveAs(blob, imgUrl.split("/").pop());
            })
            .catch(() => { });
    };

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="card mt-4">
                    <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                            <h2 className="mb-0 fs-3 d-block d-md-inline">Campaign Wise Report</h2>
                            <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                <Dropdown style={{ zIndex: 999 }}>
                                    <Dropdown.Toggle
                                        className="fw-semibold"
                                        variant="primary"
                                        style={{ minWidth: 130 }}
                                    >
                                        {selectDateName}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="p-3 Date-Filter-Menu">
                                        <div className="d-flex flex-column">
                                            <label className="mb-2 fw-semibold">From</label>
                                            <input
                                                type="date"
                                                name="from"
                                                value={Filter.from_date}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, from_date: e.target.value })
                                                }
                                                className="form-control mb-3"
                                            />

                                            <label className="mb-2 fw-semibold">To</label>
                                            <input
                                                type="date"
                                                name="to"
                                                value={Filter.to_date}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, to_date: e.target.value })
                                                }
                                                className="form-control mb-3"
                                            />

                                            <div className="d-flex justify-content-between">
                                                <button
                                                    className="btn btn-primary w-100 me-1"
                                                    onClick={() => {
                                                        if (Filter.from_date && Filter.to_date) {
                                                            setPage(1)
                                                            setSelectDateName(`${Filter.from_date} To ${Filter.to_date}`);
                                                        }
                                                    }}
                                                >
                                                    Apply
                                                </button>

                                                <button
                                                    className="btn btn-secondary w-100 ms-1"
                                                    onClick={() => {
                                                        setSelectDateName("Select Date");
                                                        setFilter({
                                                            ...Filter,
                                                            from_date: "",
                                                            to_date: ""
                                                        });
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <button
                                    onClick={handleClearSearchFilter}
                                    className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                    style={{ minWidth: 130 }}
                                >
                                    <MdClear className="fs-5" />
                                    Clear Filter
                                </button>
                                <button
                                    onClick={() => ReportDownload.refetch()}
                                    style={{ minWidth: 130 }}
                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                    disabled={ReportDownload.isFetching}
                                >
                                    <BiExport className="fs-5" />
                                    {ReportDownload.isFetching ? "Exporting.." : "Export"}

                                </button>
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body border-start-0 border-end-0 p-0">
                        <div className="table-responsive" style={{ minHeight: 500 }}>
                            <table className="table table-hover table-bordered text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: 200, minWidth: 200 }}>SR No</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Message Type</th>
                                        <th style={{ width: 200, minWidth: 200 }}>From Number</th>
                                        <th style={{ width: 200, minWidth: 200 }}>To Number</th>
                                        <th style={{ minWidth: 350 }}>User</th>
                                        <th style={{ width: 200, minWidth: 200 }}>User Role</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Direction</th>
                                        <th style={{ width: 350, minWidth: 350 }}>Media</th>
                                        <th style={{ width: 350, minWidth: 350 }}>Message</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Status</th>
                                        <th style={{ width: 250 }}>Sms Gateway Name</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Error Code</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Error Message</th>
                                        <th style={{ width: 200, minWidth: 200 }}>CreatedAt</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.message_type || ""}
                                                className="form-control w-100"
                                                onChange={(e) => setFilter({ ...Filter, message_type: e.target.value })}
                                            >
                                                <option value="">All</option>
                                                <option value="Individual">Individual</option>
                                                <option value="Broadcast">Broadcast</option>
                                            </select>
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.from}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, from: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.to}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, to: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <ReactSelect
                                                name="smscampuser"
                                                isMulti={true}
                                                isSearchable={true}
                                                options={users}
                                                className='shadow-none'
                                                value={users.filter((item) => Filter.user_id?.includes(item.id))}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id?.toString()}
                                                onChange={(e) => {
                                                    setFilter({ ...Filter, user_id: e.map((item) => item.id) })
                                                }}
                                                isClearable
                                                placeholder="Search and select user"
                                                classNamePrefix="select"
                                                styles={{
                                                }}
                                            />
                                        </th>
                                        <th>
                                        </th>
                                        <th>
                                            <select
                                                style={{ width: 240 }}
                                                value={Filter.direction || ""}
                                                className="form-control w-100"
                                                onChange={(e) => setFilter({ ...Filter, direction: e.target.value })}
                                            >
                                                <option value="">All</option>
                                                <option value="Inbound">Inbound</option>
                                                <option value="Outbound">Outbound</option>
                                            </select>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <ReactSelect
                                                name="status"
                                                isMulti={true}
                                                isSearchable={true}
                                                options={statusOption}
                                                className='shadow-none'
                                                value={statusOption.filter((item) => Filter.status.includes(item.value))!}
                                                onChange={(e) => setFilter({ ...Filter, status: e.map((item) => item.value) })}
                                                isClearable
                                                placeholder="Search and select status"
                                                classNamePrefix="select"
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.sms_gateway_name}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, sms_gateway_name: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.error_code}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, error_code: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Data && Data[0] ? (
                                        Data.map((item, i) => (
                                            <tr>
                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                <td>{item?.message_type || " - "}</td>
                                                <td>{item?.from || " - "}</td>
                                                <td>{item?.to || " - "}</td>
                                                <td>
                                                    <p className="mb-0">{item?.user?.name}</p>
                                                    <p className="mb-0">
                                                        <small>{item?.user?.email}</small>
                                                    </p>
                                                </td>
                                                <td>{item?.user?.role === 1 ? "Agent" : item?.user?.role === 2 ? "Monitor" : " - "}</td>

                                                <td>{item?.direction || " - "}</td>
                                                <td className="text-center">
                                                    <div
                                                        className={`d-flex justify-content-center px-3 gap-2 flex-wrap`}
                                                    >
                                                        {(!item?.media_url || JSON.parse(item?.media_url).length === 0) ? (
                                                            <p className="mb-0">-</p>
                                                        ) : (
                                                            isJSONString(item?.media_url) &&
                                                            JSON.parse(item?.media_url).map(
                                                                (
                                                                    item: { media_url: string; content_type: string },
                                                                    i: number
                                                                ) => {
                                                                    if (item?.content_type?.startsWith("image/"))
                                                                        return (
                                                                            <div
                                                                                className="showImages bg-dark d-block"
                                                                                key={i}
                                                                                style={{ height: 75, width: 75 }}
                                                                            >
                                                                                <FiDownload
                                                                                    color="black"
                                                                                    className="my-1 removeImageBtn p-1"
                                                                                    style={{ height: 25, width: 25 }}
                                                                                    onClick={() =>
                                                                                        downloadMedia(item?.media_url)
                                                                                    }
                                                                                />
                                                                                <img
                                                                                    style={{ width: "100%", height: "100%" }}
                                                                                    src={item?.media_url}
                                                                                    alt="img"
                                                                                    className="shadow-none object-fit-contain"
                                                                                />
                                                                            </div>
                                                                        );
                                                                    else
                                                                        return (
                                                                            <div
                                                                                className={`showImages bg-dark overflow-hidden`}
                                                                                style={{ height: 75, width: 75 }}
                                                                                key={i}
                                                                            >
                                                                                <FiDownload

                                                                                    color="black"
                                                                                    className="my-1 removeImageBtn"
                                                                                    onClick={() =>
                                                                                        downloadMedia(item?.media_url)
                                                                                    }
                                                                                />
                                                                                <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                                                                    <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                                                                        {item?.content_type ===
                                                                                            "application/vnd.ms-excel" ? (
                                                                                            <BsFiletypeXls
                                                                                                className="w-100 text-success"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                                            <BsFiletypeXlsx
                                                                                                className="w-100 text-success"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/msword" ? (
                                                                                            <BsFiletypeDoc
                                                                                                className="w-100 text-primary"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                                                                            <BsFiletypeDocx
                                                                                                className="w-100 text-primary"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : item?.content_type ===
                                                                                            "application/pdf" ? (
                                                                                            <BsFiletypePdf
                                                                                                className="w-100 text-danger"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        ) : (
                                                                                            <FaFile
                                                                                                className="w-100"
                                                                                                style={{ height: 35 }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                    <p
                                                                                        className="mb-2 fs-11 text-center"
                                                                                        style={{ fontSize: 11 }}
                                                                                    >
                                                                                        {/* {item?.name} */}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                }
                                                            )
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{maxWidth:500, textWrap:"balance", overflow:"hidden"}}>{item?.message || " - "}</td>
                                                <td className={`text-center ${item?.status === 0 ? 'text-warning fw-bold' :
                                                    item?.status === 1 ? 'text-success fw-bold' :
                                                        item?.status === 2 ? 'text-success fw-bold' :
                                                            item?.status === 3 ? 'text-danger fw-bold' :
                                                                item?.status === 4 ? 'text-danger fw-bold' :
                                                                    item?.status === 5 ? 'text-info fw-bold' :
                                                                        item?.status === 6 ? 'text-info fw-bold' :
                                                                            item?.status === 7 ? 'text-secondary fw-bold' :
                                                                                'text-muted'
                                                    }`}>
                                                    {item.status === 0 ? "Pending" :
                                                        item.status === 1 ? "Sent" :
                                                            item.status === 2 ? "Delivered" :
                                                                item.status === 3 ? "Undelivered" :
                                                                    item.status === 4 ? "Failed" :
                                                                        item.status === 5 ? "Delivery Unknown" :
                                                                            item.status === 6 ? "Delivery Unconfirmed" :
                                                                                item.status === 7 ? "Unknown Gateway" : " - "}
                                                </td>

                                                <td>{item?.sms_gateway_name || " - "}</td>
                                                <td>{item?.error_code || " - "}</td>
                                                <td>{item?.error_message || " - "}</td>
                                                <td>{formatDate(item?.createdAt) || " - "}</td>
                                            </tr>
                                        ))
                                    ) : !Report.isFetching ? (
                                        <tr>
                                            <td colSpan={14} height={50}>
                                                <div className="text-center">
                                                    <p className="mb-0 fs-5 fw-semibold">
                                                        No data found
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {Report.isFetching ? (
                                <center className="mb-3">
                                    <i
                                        className=" my-2 fa loader"
                                        style={{ fontSize: "30px", color: "black" }}
                                    ></i>
                                </center>
                            ) : null}
                        </div>
                        {info && info.total_page ? (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                <RenderPaginationButtons
                                    info={info}
                                    currentPage={page}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}
